import { useField } from "formik"
import { cloneDeep } from "lodash"
import { InputText } from "primereact/inputtext"
import { useEffect } from "react"

const FormikInputText = ({
  id,
  placeholder,
  autoFocus,
  onChange,
  className,
  type,
  disabled = false,
  noSpaces = false,
  ...props
}: $TSMigrationFixMe) => {
  const [field, meta] = useField(props)

  useEffect(() => {
    const el = document.querySelector(`input[name="${props.name}"]`)
    el?.setAttribute("autocomplete", "off")
  }, [props.name])
  const errorMsg = meta.error && meta.touched ? meta.error : ""

  const handleInputText = (e: $TSMigrationFixMe) => {
    const newEvent = cloneDeep(e)

    if (noSpaces) {
      newEvent.target.value = newEvent.target.value.replace(" ", "")
    }

    if (onChange) {
      return onChange(newEvent)
    }

    return field.onChange(newEvent)
  }

  return (
    <>
      <InputText
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        autoFocus={autoFocus}
        type={type}
        className={`${className} ${errorMsg ? "p-invalid p-d-block" : ""}`}
        autoComplete='nope'
        {...field}
        value={field.value || ""}
        onChange={handleInputText}
      />
      {errorMsg && <small className='p-error p-d-block'>{errorMsg}</small>}
    </>
  )
}

export default FormikInputText
